import { useState } from "react";

import { getUrlParams } from "../browser";

export const useSearchParams = (): Record<string, string> => {
    const [searchParams] = useState(() => getUrlParams());

    return searchParams;
};
